import { getPlatformInfo } from "../hooks/usePlatformDetection";

export const isIOS = () => {
  const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
  return /iPad|iPhone|iPod/.test(userAgent);
};

/**
 * Enhanced iOS detection using the new platform detection utility
 * @deprecated Consider using usePlatformDetection hook instead for component usage
 */
export const isIOSPlatform = () => {
  if (typeof window === "undefined") return false;
  return getPlatformInfo().isIOS;
};
